import { MouseEventHandler, createElement } from 'react';
import { HOC } from 'src/shared/componentBuilder';
import { omit } from 'lodash';
import { VacancyResponseParams, useVacancyResposne } from './useResponseVacancy';

interface ResponseClickParams extends VacancyResponseParams {
  catalogItemId: number;
  onClick?: MouseEventHandler<HTMLElement>;
  disabled?: boolean;
}

const arrOfInternalKeys: Array<keyof ResponseClickParams> = ['catalogItemId', 'responder'];

export const withVacancyResponseClick: HOC<ResponseClickParams> = (component) => (props) => {
  const [responseFeature, isLoading] = useVacancyResposne();
  const onClick: MouseEventHandler<HTMLElement> = async (event) =>
    responseFeature(props.catalogItemId, props).then((res) => res.tap(() => props.onClick?.(event)));

  return createElement(component, { ...omit(props, ...arrOfInternalKeys), onClick, disabled: isLoading || props.disabled });
};
